import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-grid-list-changer',
  templateUrl: './grid-list-changer.component.html',
  styleUrls: ['./grid-list-changer.component.css']
})
export class GridListChangerComponent {
  @Input() isListView: boolean;
  @Output() isListViewChange = new EventEmitter<boolean>();



  activateListView() {
    this.isListView = true;
    this.isListViewChange.emit(true);
  }

  activateGridView() {
    this.isListView = false;
    this.isListViewChange.emit(false);
  }
}
